import { all, call, put, takeLatest } from "redux-saga/effects";
import { normalize, schema } from "normalizr";
import { toast } from "react-toastify";
import queryString from "query-string";
import { getErrorMessage } from "utils/sagasErrorHandler";
import { ITEMS_PER_PAGE } from "constants/general";
import messageHelper from "utils/messages/messageHelper";
import { sharedHistory } from "routes/sharedHistory";
import { ROUTES_MAP } from "routes/constants";
import {
    updateBranchPartially,
    updateBranchPartiallyError,
    updateBranchPartiallySuccess,
    getBranchByCode,
    getBranchByCodeError,
    getBranchByCodeSuccess,
    getBranches,
    getBranchesError,
    getBranchesSuccess,
    updateBranch,
    updateBranchError,
    updateBranchSuccess,
    deleteBranch,
    setSelectedBranches,
    createBranchSuccess,
    createBranchError,
    createBranch,
} from "modules/Branches/services/Branches/actions";
import {
    getBranchByCodeRequest,
    getBranchesRequest,
    updateBranchRequest,
    deleteBranchRequest,
    createBranchRequest,
    updatePartiallyBranchRequest
} from "modules/Branches/services/Branches/api";

const branchesSchema = new schema.Entity("branches" , {},{ idAttribute: "code" });
const branchesListSchema = new schema.Array(branchesSchema);

//Workers
function* handleRefreshBranches() {
    const { search } = window.location;
    yield put(setSelectedBranches([]));
    yield put(getBranches({ limit: ITEMS_PER_PAGE, ...queryString.parse(search) }));
}

function* handleGetBranches ({ payload }) {
    try {
        const { branches, count } = yield call(getBranchesRequest, payload);
        const { result, entities } = normalize(branches, branchesListSchema);
        yield put(getBranchesSuccess({
            branches: JSON.stringify(entities) === JSON.stringify({}) ? [] : entities.branches,
            codes: result,
            count
        }));
    } catch (error) {
        yield put(getBranchesError());
        getErrorMessage(error);
    }
}

function* handleGetBranchByCode ({ payload }) {
    try {
        const branch = yield call(getBranchByCodeRequest, payload);
        yield put(getBranchByCodeSuccess(branch));
    } catch (error) {
        yield put(getBranchByCodeError());
        getErrorMessage(error);
    }
}

function* handleUpdateBranch ({ payload }) {
    try {
        yield call(updateBranchRequest, payload);
        yield call(toast.success, `The branch with code - ${payload.code} has been successfully updated`);
        sharedHistory.push(ROUTES_MAP.branches.path);
        yield put(updateBranchSuccess());
    } catch (error) {
        yield put(updateBranchError());
        getErrorMessage(error);
    }
}

function* handleUpdateBranchPartially ({ payload }) {
    try {
        const branch = yield call(updatePartiallyBranchRequest, payload);
        yield call(toast.success, `The branch with code - ${payload.code} has been successfully updated`);
        yield put(updateBranchPartiallySuccess(branch));
    } catch (error) {
        yield put(updateBranchPartiallyError());
        getErrorMessage(error);
    }
}

function* handleDeleteBranch ({ payload }) {
    try {
        yield all(payload.map((payload) => call(deleteBranchRequest, payload)));
        yield handleRefreshBranches();
        messageHelper({
            type: "success",
            actionSubject: `Branch${payload.length > 1 ? "es" : ""} with id${payload.length > 1 ? "s" : ""} - ${payload.join(", ")}`,
            action: "deleted",
            plural: payload.length > 1
        });
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleCreateBranch ({ payload }) {
    try {
        yield call(createBranchRequest, payload);
        yield put(createBranchSuccess());
        yield call(toast.success, "The branch has been successfully created");
        sharedHistory.push(ROUTES_MAP.branches.path);
    } catch (error) {
        yield put(createBranchError());
        getErrorMessage(error);
    }
}

// Watchers
export function* branchesEntriesSagas() {
    yield all([
        yield takeLatest(getBranches, handleGetBranches),
        yield takeLatest(createBranch, handleCreateBranch),
        yield takeLatest(getBranchByCode, handleGetBranchByCode),
        yield takeLatest(updateBranch, handleUpdateBranch),
        yield takeLatest(updateBranchPartially, handleUpdateBranchPartially),
        yield takeLatest(deleteBranch, handleDeleteBranch),
    ]);
}
